module.exports = __webpack_public_path__ + "img/BZ.107aaa3d.svg";